<section fxLayout="column" fxFlexAlign="center">
  <div class="maindiv" fxLayout="column" fxFlexAlign="center">
    <img src="assets/images/logoSchaufler.jpg">

    <h1>Willkommen bei Schaufler ARP</h1>
  </div>

</section>

